var scope_0 = require('/home/runner/work/workplace-xg/workplace-xg/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2684da9c81a263b7b051c680d8abf268.js').default;
var scope_1 = require('/home/runner/work/workplace-xg/workplace-xg/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2ab41c2375254c66740c7f30fe5c96c8.js').default;
var scope_2 = require('/home/runner/work/workplace-xg/workplace-xg/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3ae8db34296c64c01d76d12e960840e0.js').default;
var scope_3 = require('/home/runner/work/workplace-xg/workplace-xg/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3d5582906dd66898ffbfcaf76b9966cd.js').default;
var scope_4 = require('/home/runner/work/workplace-xg/workplace-xg/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3f163a45143d89a03e46da816b181bb8.js').default;
var scope_5 = require('/home/runner/work/workplace-xg/workplace-xg/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4caedb40e24a475ec17c64ed50f50bb1.js').default;
var scope_6 = require('/home/runner/work/workplace-xg/workplace-xg/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c6fa52fdce6d358c3c70379eacf1afc4.js').default;
var scope_7 = require('/home/runner/work/workplace-xg/workplace-xg/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cf07b22909a813a55e812c2477e59e9f.js').default;
var scope_8 = require('/home/runner/work/workplace-xg/workplace-xg/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/db6e313a63873b6e4324484f85fe6609.js').default;
var scope_9 = require('/home/runner/work/workplace-xg/workplace-xg/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e1b7976d5f9891b1eac632542813af8d.js').default;
var scope_10 = require('/home/runner/work/workplace-xg/workplace-xg/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10 )
    